import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('usuario');
    
    if (token && savedUser) {
      setUsuario(JSON.parse(savedUser));
      authService.me()
        .then(res => setUsuario(res.data.data))
        .catch(() => logout());
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await authService.login({ username, password });
    const { usuario, token } = response.data.data;
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usuario));
    setUsuario(usuario);
    return usuario;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  const hasPermission = (...roles) => {
    if (!usuario) return false;
    if (usuario.rol === 'ADMIN') return true;
    return roles.includes(usuario.rol);
  };

  return (
    <AuthContext.Provider value={{ usuario, loading, login, logout, hasPermission, isAuthenticated: !!usuario }}>
      {children}
    </AuthContext.Provider>
  );
};
